// extracted by mini-css-extract-plugin
module.exports = {"superElipse":"super-ellipse-skins-xlarge-superElipse-0e76d1b3","strokeWidth":"super-ellipse-skins-xlarge-strokeWidth-4fde92ed"};